import React from "react";
import useTheme from "../../../../common/hooks/useTheme";
import { Theme } from "../../../../providers/ThemeProvider";
import InlineBanner from "../common/InlineBanner";
import WorkoutPlanTab from "./WorkoutPlanTab";
import WorkoutPlanSkeleton from "./workoutPlan/components/shared/WorkoutPlanSkeleton";
import { useWorkoutPlan } from "./workoutPlan/store/useWorkoutPlan";
import WorkoutPlanView from "./workoutPlan/WorkoutPlanView";

/**
 * Programming → Workout. A subject with a weekly workout plan in the
 * Precision app gets the plan (ported from the mobile WorkoutTab); everyone
 * else keeps the report-based summary in `WorkoutPlanTab`. There is no
 * backend flag for a workout plan, so `WorkoutPlanProvider` (mounted by
 * `ProgrammingScreen`) decides from the first load of the current week; a
 * failed probe shows the error rather than quietly falling back to the
 * report, so an outage never reads as "no plan".
 */
const WorkoutProgrammingTab = () => {
  const theme: Theme = useTheme();
  const { planAvailability, probeStatus, reload } = useWorkoutPlan();

  if (planAvailability === "available") return <WorkoutPlanView />;
  if (planAvailability === "none") return <WorkoutPlanTab />;
  if (probeStatus === "error") {
    return (
      <InlineBanner
        text="Couldn't load the workout plan."
        backgroundColor={theme.colorTokens.D[10]}
        iconColor={theme.colorTokens.D[70]}
        action={{ label: "Retry", onClick: reload }}
      />
    );
  }
  return <WorkoutPlanSkeleton />;
};

export default WorkoutProgrammingTab;
